import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { ProductBoughtDataType } from '../../types/product';

const serializer = (data) => {
  const obj: ProductBoughtDataType = {
    canReview: !!data?.can_review,
  };
  return obj;
};

const checkIsProductBought = async (productId: number) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/custom/reviews/latest/customer/${productId}`;

  const { response, error }: any = await getMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: true }),
  });

  if (response?.data) {
    return { response: serializer(response?.data) };
  } else {
    return { error };
  }
};

export default checkIsProductBought;
